<template>
  <div id="app" >
    <Navbar v-if="activeNavbar"/>
    <keep-alive :include="keepAliveViews">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import { isFeedInventoryOnly } from "./utils/feedInventoryAccess";

const FEED_ONLY_ROUTE = "FeedInventoryAllBarnsPage";

export default {
  components: {
    Navbar
  },
  computed: {
    activeNavbar() {
      return this.$store.getters.getNavbar;
    },
    keepAliveViews() {
      return this.$store.getters.getLogedIn ? ['HomePage'] : [];
    },
    feedInventoryOnly() {
      return isFeedInventoryOnly(
        this.$store.getters.getCurrentUser,
        this.$store.getters.getCompanySettings,
      )
    },
  },
  watch: {
    $route() {
      this.leaveIfFeedOnly()
    },
    feedInventoryOnly() {
      this.leaveIfFeedOnly()
    },
  },
  mounted() {
    this.leaveIfFeedOnly()
  },
  methods: {
    leaveIfFeedOnly() {
      if (!this.feedInventoryOnly) return
      if (this.$route.name === FEED_ONLY_ROUTE || this.$route.name === "Login") return
      this.$router.replace({ name: FEED_ONLY_ROUTE })
    },
  },
}
</script>

<style>
body {
  background: #f2f2f2;
  font-family: "Roboto", sans-serif;
  margin: 0;
}

:root {
  --light-green: #78b843;
}

.conteudo {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  margin-top: 40px;
}
</style>
